import { createIntervalFromString } from 'utils/createIntervalFromString';
import { axiosInstance } from './api'

export const publisherDashboardApi = {
  getAdSpotViews(id: number, params: { interval: string; metaverse: string }) {
    return axiosInstance.post<{ ad_spots_views: number; stats: { day: string; total_shows: number }[] }>(
      `publisher/dashboard/ad-spots${id ? '/' + id : ''}`,//@ts-ignore
      {...createIntervalFromString(params.interval), metaverse: params.metaverse}
    )
  },
  downloadReport(id: number) {
    return axiosInstance.get(`publisher/report/ad-spots${id ? '/' + id : ''}`, {
      responseType: 'blob',
    })
  },
}
